module.exports = __webpack_public_path__ + "static/media/Observadores_Ciudadania-Organizacion.18580b70.png";